module.exports = __webpack_public_path__ + "static/media/companynewsImg4.d6c0366a.jpg";